
// cart-utils.js (Non-module version)
const _cartUtilsLog = window.createLogger("CartUtils");

window.CartUtils = (function () {
  async function fetchCart() {
    try {
      const res = await fetch("/cart.js");
      if (!res.ok) throw new Error("Failed to fetch cart");
      const response = await res.json();
      return response;
    } catch (err) {
      _cartUtilsLog.error("fetchCart() error:", err);
      return null;
    }
  }

  async function getCartTotal() {
    const cart = await fetchCart();
    if (!cart || typeof cart.total_price === "undefined") return 0;
    return Number(cart.total_price);
  }

  async function getCartSummary() {
    const cart = await fetchCart();
    if (!cart) return { total: 0, currency: "EUR", item_count: 0 };
    return {
      total: cart.total_price,
      currency: cart.currency,
      item_count: cart.item_count,
    };
  }
  async function getCartItems() {
    const cart = await fetchCart();
    return cart?.items || [];
  }

  // Return globally accessible functions
  return { fetchCart, getCartTotal, getCartItems, getCartSummary };
})();
